import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=287e3ae0&scoped=true"
import script from "./ColorPicker.vue?vue&type=script&lang=js"
export * from "./ColorPicker.vue?vue&type=script&lang=js"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&id=287e3ae0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287e3ae0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('287e3ae0')) {
      api.createRecord('287e3ae0', component.options)
    } else {
      api.reload('287e3ae0', component.options)
    }
    module.hot.accept("./ColorPicker.vue?vue&type=template&id=287e3ae0&scoped=true", function () {
      api.rerender('287e3ae0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/helper/ColorPicker.vue"
export default component.exports